module.exports = {"fieldList":["phone","password","symbol","detail","name","realname","new_pwd","old_pwd","number","pwd","mobile","email","pp_question","pp_answer","telephone","credit_card","bank_card","fax","address","id_card","fingerprint","account","pwd_pay","express_number","order_number","id","bank_no"],"version":"1.19"}


//////////////////
// WEBPACK FOOTER
// ./src/safeField.json
// module id = 8rxC
// module chunks = 0